<script lang="ts">
  export let title: string;
  export let image: string;
</script>

<div class="category-card">
  <img src={image} alt={title} />
  <div class="overlay">
    <span class="title">{title}</span>
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .category-card {
    position: relative;
    width: 371px;
    height: 329px;
    border-radius: 20px;
    overflow: hidden;
    // cursor: pointer;
    flex: 0 0 371px;
    @include desktop-max-width {
      width: 110px;
      height: 98px;
      border-radius: 15px;
      flex: 0 0 110px;
    }
  }

  .category-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .overlay {
    position: absolute;
    inset: 0;
    color: rgba(0, 77, 126, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-weight: 700;
    font-size: 38px;
    line-height: 48px;
    text-align: center;
    text-transform: uppercase;
    color: $primary-white;
    width: 90%;
    @include desktop-max-width {
      font-size: 12px;
      line-height: 16px;
    }
  }
</style>
